"use client";
import Link from "next/link";
import SmallImagesNewsCard from "../Helper/SmallImagesNewsCard";
import Title from "../Helper/Title";
import Breadcrumb from "../Posts/PostDetails/Breadcrumb";
import CategoryList from "./CategoryList";
import dynamic from "next/dynamic";
const Pagination = dynamic(() => import("antd/es/pagination"), {
  ssr: false,
});
import { useRouter } from "next/navigation";
import { MobileAdUnit, SidebarAd } from "../AdsBox/AdsBox";
import { useIsMobile } from "@/app/Hooks/useIsMobile";
const Category = ({
  newsPostedByAuthorData,
  authorSlug,
  currentPage,
  meta,
  viralNews,
  authorDetails,
}) => {
  const isMobile = useIsMobile();
  const router = useRouter();

  const handlePageChange = (page, authorSlug) => {
    router.push(`/author/${authorSlug}/page/${page}`);
  };

  const breadcrumbs = [
    ...(authorDetails?.breadcrumbs || []),
    ...(currentPage > 1
      ? [
          {
            label: `Page ${currentPage}`,
            url: "",
          },
        ]
      : []),
  ];

  const design = (
    <>
      <div className=" mt-3">
        <div className="w-full bg-white py-6">
          <div
            className="max-w-3xl mx-auto 
           flex flex-col items-start
           lg:items-center"
          >
            <div
              className="flex items-start gap-5 w-full
             lg:justify-center lg:text-left"
            >
              <img
                src={authorDetails?.avatar}
                alt={authorDetails?.name}
                className="w-24 h-24 rounded-full object-cover"
              />

              <div>
                <Breadcrumb breadcrumbs={breadcrumbs} />

                <h1 className="text-2xl font-bold text-gray-900">
                  {authorDetails?.name}
                </h1>

                <p className="text-gray-600 mt-2 max-w-2xl">
                  {authorDetails?.bio}
                </p>

                <div className="flex items-center gap-2 mt-3 text-gray-600">
                  {/* Facebook Share */}
                  {authorDetails?.social?.facebook && (
                    <Link
                      href={authorDetails?.social?.facebook || "#"}
                      target="_blank"
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        version="1.2"
                        baseProfile="tiny"
                        viewBox="0 0 24 24"
                        height="1.7em"
                        width="1.7em"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M13 10h3v3h-3v7h-3v-7h-3v-3h3v-1.255c0-1.189.374-2.691 1.118-3.512.744-.823 1.673-1.233 2.786-1.233h2.096v3h-2.1c-.498 0-.9.402-.9.899v2.101z"></path>
                      </svg>
                    </Link>
                  )}

                  {/* Twitter Share */}

                  {authorDetails?.social?.twitter && (
                    <Link
                      href={authorDetails?.social?.twitter || "#"}
                      target="_blank"
                    >
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 512 512"
                        height="1.2em"
                        width="1.2em"
                        className="mt-1"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
                      </svg>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 border-t pt-6 my-6 ">
          {/* LEFT - unchanged core UI */}
          <div className="lg:col-span-8">
            <CategoryList newsPostedByAuthorData={newsPostedByAuthorData} />

            <div className="flex justify-center lg:justify-start pt-5 ">
              <Pagination
                onChange={(e) => handlePageChange(e, authorSlug)}
                defaultCurrent={currentPage}
                total={meta?.total}
                pageSize={meta?.pageSize}
              />
            </div>
          </div>

          {/* RIGHT - new design */}
          <div className="lg:col-span-4">
            {/* <RightSidebar /> */}
            {isMobile ? <MobileAdUnit /> : <SidebarAd />}
            <aside className="order-3 lg:order-3 lg:col-span-3   mt-4">
              {/* related news */}
              <div className="mb-5">
                <Title size="18px">वायरल खबरें</Title>
              </div>

              <div className="space-y-5">
                {viralNews?.map((item, index) => (
                  <div key={index} className="border-b pb-3">
                    <SmallImagesNewsCard
                      title="खेल"
                      subtitle={item?.title}
                      image={item?.thumbnail}
                      imageAlt={item?.thumbnail_alt}
                      showDot
                      showMainTitle
                      fontWeight="800"
                      isVideo={item?.is_video}
                      href={item.permalink}
                      subtitleProps={{
                        size: "15px",
                        lineHeight: "20px",
                        className: "cursor-pointer",
                      }}
                    />
                  </div>
                ))}
              </div>
            </aside>
          </div>
        </div>
      </div>
    </>
  );
  return design;
};

export default Category;
